const concat = "<br />"

const keertanaIssuer = {
    "About Issuer and the Issue": [
        {
          question: "Who is the issuer of the bond?",
          answer: "Keertana Finserv Private Limited is the issuer of the Bond"
        },
        {
          question: "What is the security of my investments?",
          answer: "The bond issue is secured by Gold Loans and has a security cover of 1.1x."
        },
        {
          question: "What are the financials of the Issuer?",
          answer:  "<b>Business Metrics – FY23</b>" + concat +
          "AUM: 609 cr" + concat +
          "Avg. Yield/ NIMs: 25.6% / 15.6%" + concat +
          "Debt/ Equity 3x & CRAR:  27%" + concat +
          "GNPA / NNPA: 0.01% / 0.0%" + concat +
          "PAT: 21.4 cr" + concat +
          "Average Ticket Size: 70K" + concat +
          "Loan tenure: 6-12 Months " + concat +
          "ROA/ ROE: 6% / 18% "
        },
        {
          question: "What are the important details of the Bond offering?",
          answer:  "Coupon Rate: 11.65% p.a" + concat +
          "Coupon Frequency: Monthly" + concat +
          "Principal Repayment: Quarterly" + concat +
          "ISIN: INE0NES07030" + concat +
          "Debenture Trustee: Catalyst Trusteeship Ltd." + concat +
          "Credit Rating: CRISIL BBB/Stable" + concat +
          "Listing Details: Bombay Stock Exchange (BSE)" + concat +
          "Coupon : Fixed" + concat +
          "Original Mode of Issue: Private Placement"+ concat +
          "Date of Issue: 24th June ‘23"
        },
        {
          question: "How is the Yield to Maturity (YTM) is calculated?",
          answer: "The Yield to Maturity is calculated using the XIRR formula present in Microsoft Excel or such other spreadsheets. The cash flow is populated in the spreadsheet along with the dates and the XIRR formula is then applied to get the YTM."
        }
      ],
  }
  
  export default keertanaIssuer;